'use client';

interface CustomButtonProps {
  label?: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode | null;
}

const CustomButton = ({ label, onClick, disabled, className, style, children = null }: CustomButtonProps) => {
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={`cursor-pointer ${className}`} style={style}>
      {children ? children : label}
    </button>
  );
};

export default CustomButton;
